import { render } from "./tw-ws-dashboard.vue?vue&type=template&id=5815d276"
import script from "./tw-ws-dashboard.vue?vue&type=script&lang=js"
export * from "./tw-ws-dashboard.vue?vue&type=script&lang=js"
script.render = render

export default script